import React from "react";
import PropTypes from "prop-types";
import ColorPicker from "../ColorPicker";
import Tooltip from "@material-ui/core/Tooltip";
import withMobileContext from "../../decorators/withMobileContext";
import FormatColorTextWithShadowIcon from "../../../../icons/FormatColorTextWithShadowIcon";
import trackEvent from "../../../../utils/track-event";

function TextColor(props) {
  const {current, handleChange, isMobile} = props;
  return (
    <ColorPicker
      color={current}
      onChange={(e, pickerType) => {
        handleChange(`fill`)(e);
        if (pickerType === `palette`) {
          trackEvent({
            category: `Editor`,
            action: `Palette`,
            label: `Font`
          });
        }
      }}
      position={isMobile ? `top-center` : `bottom-right`}
    >
      <Tooltip title="Цвет текста">
        <div className="palette" style={{backgroundColor: current}}>
          <FormatColorTextWithShadowIcon />
        </div>
      </Tooltip>
    </ColorPicker>
  );
}

TextColor.propTypes = {
  current: PropTypes.string,
  handleChange: PropTypes.func,
  isMobile: PropTypes.bool
};

export default withMobileContext(TextColor);
